import { Heading } from '@cleartax/wg-library-typography';
import { PropsWithChildren } from 'react';

interface ISectionHeading {
  className?: string;
}
export const SectionHeading: React.FC<PropsWithChildren<ISectionHeading>> = ({
  children,
  className = '',
}) => {
  return (
    <Heading
      type="h5"
      textSize="2xl"
      weight="bold"
      className={`text-brand-1000 ${className}`}
    >
      {children}
    </Heading>
  );
};
